export class Solution {
  id: string | undefined;

  constructor(s: Partial<Solution>) {
    // TODO:
    //if (!s.id) {
    //    throw new Error(`Invalid solution in constructor: ${JSON.stringify(s)} id cannot be null`);
    //}

    this.id = s.id;
  }
}
